"use client";
import { c as POPOVER_MOTION_PROPS, n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { _ as useTheme_v2, d as createGlobalScopedContext, i as usePrefersReducedMotion, s as Card } from "./useLayer-BAVfmbNN.js";
import { n as AnimateActivity, r as origin, t as getElementRef } from "./getElementRef-5HZQ-Owu.js";
import { a as useBoundaryElement, n as Portal, r as usePortal, t as Arrow } from "./arrow-CHE8-_G7.js";
import { t as Layer } from "./layer-B98ynOf2.js";
import { c } from "react/compiler-runtime";
import { Activity, cloneElement, useContext, useEffect, useId, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { styled } from "styled-components";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { arrow, autoUpdate, flip, offset, shift, useFloating } from "@floating-ui/react-dom";
import { motion } from "motion/react";
import { useEffectEvent } from "use-effect-event";
/**
* @beta
*/
function useDelayedState(initialState) {
	let $ = c(5), [state, setState] = useState(initialState), delayedAction = useRef(void 0), t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = (nextState, delay) => {
		let action = () => {
			setState(nextState);
		};
		if (delayedAction.current &&= (clearTimeout(delayedAction.current), void 0), !delay) return action();
		delayedAction.current = setTimeout(action, delay);
	}, $[0] = t0) : t0 = $[0];
	let onStateChange = t0, t1, t2;
	$[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => () => {
		delayedAction.current && clearTimeout(delayedAction.current);
	}, t2 = [], $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
	let t3;
	return $[3] === state ? t3 = $[4] : (t3 = [state, onStateChange], $[3] = state, $[4] = t3), t3;
}
const DEFAULT_FALLBACK_PLACEMENTS = {
	top: [
		"top-end",
		"top-start",
		"bottom",
		"left",
		"right"
	],
	"top-start": [
		"top",
		"top-end",
		"bottom-start",
		"left-start",
		"right-start"
	],
	"top-end": [
		"top",
		"top-start",
		"bottom-end",
		"left-end",
		"right-end"
	],
	bottom: [
		"bottom-end",
		"bottom-start",
		"top",
		"left",
		"right"
	],
	"bottom-start": [
		"bottom",
		"bottom-end",
		"top-start",
		"left-start",
		"right-start"
	],
	"bottom-end": [
		"bottom",
		"bottom-start",
		"top-end",
		"left-end",
		"right-end"
	],
	left: [
		"left-end",
		"left-start",
		"right",
		"top",
		"bottom"
	],
	"left-start": [
		"left",
		"left-end",
		"right-start",
		"top-start",
		"bottom-start"
	],
	"left-end": [
		"left",
		"left-start",
		"right-end",
		"top-end",
		"bottom-end"
	],
	right: [
		"right-end",
		"right-start",
		"left",
		"top",
		"bottom"
	],
	"right-start": [
		"right",
		"right-end",
		"left-start",
		"top-start",
		"bottom-start"
	],
	"right-end": [
		"right",
		"right-start",
		"left-end",
		"top-end",
		"bottom-end"
	]
}, MotionCard = styled(motion.create(Card)).withConfig({
	displayName: "MotionCard",
	componentId: "sc-njeaip-0"
})`will-change:transform;`;
/**
* @internal
*/
function TooltipCard(props) {
	let $ = c(49), animate, arrow, arrowRef, arrowX, arrowY, children, originX, originY, padding, placement, radius, ref, restProps, scheme, shadow, style;
	$[0] === props ? (animate = $[1], arrow = $[2], arrowRef = $[3], arrowX = $[4], arrowY = $[5], children = $[6], originX = $[7], originY = $[8], padding = $[9], placement = $[10], radius = $[11], ref = $[12], restProps = $[13], scheme = $[14], shadow = $[15], style = $[16]) : ({animate, arrow, arrowRef, arrowX, arrowY, children, originX, originY, padding, placement, radius, ref, scheme, shadow, style, ...restProps} = props, $[0] = props, $[1] = animate, $[2] = arrow, $[3] = arrowRef, $[4] = arrowX, $[5] = arrowY, $[6] = children, $[7] = originX, $[8] = originY, $[9] = padding, $[10] = placement, $[11] = radius, $[12] = ref, $[13] = restProps, $[14] = scheme, $[15] = shadow, $[16] = style);
	let t0 = animate ? "transform" : void 0, t1;
	$[17] !== originX || $[18] !== originY || $[19] !== style || $[20] !== t0 ? (t1 = {
		originX,
		originY,
		willChange: t0,
		...style
	}, $[17] = originX, $[18] = originY, $[19] = style, $[20] = t0, $[21] = t1) : t1 = $[21];
	let rootStyle = t1, t2 = arrowX === null ? void 0 : arrowX, t3 = arrowY === null ? void 0 : arrowY, t4;
	$[22] !== t2 || $[23] !== t3 ? (t4 = {
		left: t2,
		top: t3,
		right: void 0,
		bottom: void 0
	}, $[22] = t2, $[23] = t3, $[24] = t4) : t4 = $[24];
	let arrowStyle = t4, t5;
	$[25] === animate ? t5 = $[26] : (t5 = animate ? ["hidden", "initial"] : void 0, $[25] = animate, $[26] = t5);
	let t6;
	$[27] === animate ? t6 = $[28] : (t6 = animate ? ["visible", "scaleIn"] : void 0, $[27] = animate, $[28] = t6);
	let t7;
	$[29] === animate ? t7 = $[30] : (t7 = animate ? ["hidden", "scaleOut"] : void 0, $[29] = animate, $[30] = t7);
	let t8;
	$[31] !== arrow || $[32] !== arrowRef || $[33] !== arrowStyle ? (t8 = arrow && /* @__PURE__ */ jsx(Arrow, {
		ref: arrowRef,
		style: arrowStyle,
		width: 15,
		height: 6,
		radius: 2
	}), $[31] = arrow, $[32] = arrowRef, $[33] = arrowStyle, $[34] = t8) : t8 = $[34];
	let t9;
	return $[35] !== children || $[36] !== padding || $[37] !== placement || $[38] !== radius || $[39] !== ref || $[40] !== restProps || $[41] !== rootStyle || $[42] !== scheme || $[43] !== shadow || $[44] !== t5 || $[45] !== t6 || $[46] !== t7 || $[47] !== t8 ? (t9 = /* @__PURE__ */ jsxs(MotionCard, {
		"data-ui": "Tooltip__card",
		...restProps,
		"data-placement": placement,
		padding,
		radius,
		ref,
		scheme,
		shadow,
		style: rootStyle,
		variants: POPOVER_MOTION_PROPS.card,
		transition: POPOVER_MOTION_PROPS.transition,
		initial: t5,
		animate: t6,
		exit: t7,
		children: [children, t8]
	}), $[35] = children, $[36] = padding, $[37] = placement, $[38] = radius, $[39] = ref, $[40] = restProps, $[41] = rootStyle, $[42] = scheme, $[43] = shadow, $[44] = t5, $[45] = t6, $[46] = t7, $[47] = t8, $[48] = t9) : t9 = $[48], t9;
}
/**
* @beta
*/
const TooltipDelayGroupContext = createGlobalScopedContext("@sanity/ui/context/tooltipDelayGroup", null);
/**
* @beta
*/
function useTooltipDelayGroup() {
	return useContext(TooltipDelayGroupContext);
}
const StyledTooltip = styled(Layer).withConfig({
	displayName: "StyledTooltip",
	componentId: "sc-8cbl5k-0"
})`pointer-events:none;`;
/**
* Tooltips display information when hovering, focusing or tapping.
*
* @public
*/
function Tooltip(props) {
	let $ = c(138), boundaryElementContext = useBoundaryElement(), { layer } = useTheme_v2(), _boundaryElement, _fallbackPlacementsProp, _zOffset, childProp, content, delay, disabled, forwardedRef, portalProp, restProps, scheme, t0, t1, t2, t3, t4, t5;
	$[0] === props ? (_boundaryElement = $[1], _fallbackPlacementsProp = $[2], _zOffset = $[3], childProp = $[4], content = $[5], delay = $[6], disabled = $[7], forwardedRef = $[8], portalProp = $[9], restProps = $[10], scheme = $[11], t0 = $[12], t1 = $[13], t2 = $[14], t3 = $[15], t4 = $[16], t5 = $[17]) : ({animate: t0, arrow: t1, boundaryElement: _boundaryElement, children: childProp, content, disabled, fallbackPlacements: _fallbackPlacementsProp, padding: t2, placement: t3, portal: portalProp, radius: t4, ref: forwardedRef, scheme, shadow: t5, zOffset: _zOffset, delay, ...restProps} = props, $[0] = props, $[1] = _boundaryElement, $[2] = _fallbackPlacementsProp, $[3] = _zOffset, $[4] = childProp, $[5] = content, $[6] = delay, $[7] = disabled, $[8] = forwardedRef, $[9] = portalProp, $[10] = restProps, $[11] = scheme, $[12] = t0, $[13] = t1, $[14] = t2, $[15] = t3, $[16] = t4, $[17] = t5);
	let _animate = t0 !== void 0 && t0, arrowProp = t1 !== void 0 && t1, padding = t2 === void 0 ? 2 : t2, placementProp = t3 === void 0 ? "bottom" : t3, radius = t4 === void 0 ? 2 : t4, shadow = t5 === void 0 ? 2 : t5, boundaryElement = _boundaryElement ?? boundaryElementContext?.element, fallbackPlacementsProp = _fallbackPlacementsProp ?? DEFAULT_FALLBACK_PLACEMENTS[props.placement ?? "bottom"], zOffset = _zOffset ?? layer.tooltip.zOffset, animate = !usePrefersReducedMotion() && _animate, t6;
	$[18] === fallbackPlacementsProp ? t6 = $[19] : (t6 = _getArrayProp(fallbackPlacementsProp), $[18] = fallbackPlacementsProp, $[19] = t6);
	let fallbackPlacements = t6, ref = useRef(null), [referenceElement, setReferenceElement] = useState(null), arrowRef = useRef(null), [tooltipMaxWidth, setTooltipMaxWidth] = useState(0), t7;
	$[20] === Symbol.for("react.memo_cache_sentinel") ? (t7 = () => ref.current, $[20] = t7) : t7 = $[20], useImperativeHandle(forwardedRef, t7);
	let portal = usePortal(), portalElement = typeof portalProp == "string" ? portal.elements?.[portalProp] || null : portal.element, t8;
	$[21] !== animate || $[22] !== arrowProp || $[23] !== boundaryElement || $[24] !== fallbackPlacements ? (t8 = {
		animate,
		arrowProp,
		arrowRef,
		boundaryElement,
		fallbackPlacements,
		rootBoundary: "viewport"
	}, $[21] = animate, $[22] = arrowProp, $[23] = boundaryElement, $[24] = fallbackPlacements, $[25] = t8) : t8 = $[25];
	let middleware = useMiddleware(t8), t9;
	$[26] === referenceElement ? t9 = $[27] : (t9 = { reference: referenceElement }, $[26] = referenceElement, $[27] = t9);
	let t10;
	$[28] !== middleware || $[29] !== placementProp || $[30] !== t9 ? (t10 = {
		middleware,
		placement: placementProp,
		whileElementsMounted: autoUpdate,
		elements: t9
	}, $[28] = middleware, $[29] = placementProp, $[30] = t9, $[31] = t10) : t10 = $[31];
	let { floatingStyles, placement, middlewareData, refs, update } = useFloating(t10), arrowX = middlewareData.arrow?.x, arrowY = middlewareData.arrow?.y, originX = middlewareData["@sanity/ui/origin"]?.originX, originY = middlewareData["@sanity/ui/origin"]?.originY, tooltipId = useId(), [isOpen, setIsOpen] = useDelayedState(!1), delayGroupContext = useTooltipDelayGroup(), t11;
	$[32] === delayGroupContext ? t11 = $[33] : (t11 = delayGroupContext || {}, $[32] = delayGroupContext, $[33] = t11);
	let { setIsGroupActive, setOpenTooltipId } = t11, showTooltip = isOpen || delayGroupContext?.openTooltipId === tooltipId, isInsideGroup = delayGroupContext !== null, openDelayProp = typeof delay == "number" ? delay : delay?.open || 0, closeDelayProp = typeof delay == "number" ? delay : delay?.close || 0, openDelay = isInsideGroup ? delayGroupContext.openDelay : openDelayProp, closeDelay = isInsideGroup ? delayGroupContext.closeDelay : closeDelayProp, t12;
	$[34] !== closeDelay || $[35] !== isInsideGroup || $[36] !== openDelay || $[37] !== setIsGroupActive || $[38] !== setIsOpen || $[39] !== setOpenTooltipId || $[40] !== tooltipId ? (t12 = (open, immediate) => {
		if (isInsideGroup) {
			if (open) {
				let groupedOpenDelay = immediate ? 0 : openDelay;
				setIsGroupActive?.(open, groupedOpenDelay), setOpenTooltipId?.(tooltipId, groupedOpenDelay);
			} else setIsGroupActive?.(open, closeDelay > 200 ? closeDelay : 200), setOpenTooltipId?.(null, immediate ? 0 : closeDelay);
		} else setIsOpen(open, immediate ? 0 : open ? openDelay : closeDelay);
	}, $[34] = closeDelay, $[35] = isInsideGroup, $[36] = openDelay, $[37] = setIsGroupActive, $[38] = setIsOpen, $[39] = setOpenTooltipId, $[40] = tooltipId, $[41] = t12) : t12 = $[41];
	let handleIsOpenChange = t12, t13;
	$[42] !== childProp?.props || $[43] !== handleIsOpenChange ? (t13 = (e) => {
		handleIsOpenChange(!1), childProp?.props?.onBlur?.(e);
	}, $[42] = childProp?.props, $[43] = handleIsOpenChange, $[44] = t13) : t13 = $[44], childProp?.props;
	let handleBlur = t13, t14;
	$[45] !== childProp?.props || $[46] !== handleIsOpenChange ? (t14 = (e_0) => {
		handleIsOpenChange(!1, !0), childProp?.props.onClick?.(e_0);
	}, $[45] = childProp?.props, $[46] = handleIsOpenChange, $[47] = t14) : t14 = $[47], childProp?.props;
	let handleClick = t14, t15;
	$[48] !== childProp?.props || $[49] !== handleIsOpenChange ? (t15 = (e_1) => {
		handleIsOpenChange(!1, !0), childProp?.props.onContextMenu?.(e_1);
	}, $[48] = childProp?.props, $[49] = handleIsOpenChange, $[50] = t15) : t15 = $[50], childProp?.props;
	let handleContextMenu = t15, t16;
	$[51] !== childProp?.props || $[52] !== handleIsOpenChange ? (t16 = (e_2) => {
		handleIsOpenChange(!0), childProp?.props?.onFocus?.(e_2);
	}, $[51] = childProp?.props, $[52] = handleIsOpenChange, $[53] = t16) : t16 = $[53], childProp?.props;
	let handleFocus = t16, t17;
	$[54] !== childProp?.props || $[55] !== handleIsOpenChange ? (t17 = (e_3) => {
		handleIsOpenChange(!0), childProp?.props?.onMouseEnter?.(e_3);
	}, $[54] = childProp?.props, $[55] = handleIsOpenChange, $[56] = t17) : t17 = $[56], childProp?.props;
	let handleMouseEnter = t17, t18;
	$[57] !== childProp?.props || $[58] !== handleIsOpenChange ? (t18 = (e_4) => {
		handleIsOpenChange(!1), childProp?.props?.onMouseLeave?.(e_4);
	}, $[57] = childProp?.props, $[58] = handleIsOpenChange, $[59] = t18) : t18 = $[59], childProp?.props;
	let handleMouseLeave = t18, t19;
	$[60] !== handleIsOpenChange || $[61] !== isInsideGroup || $[62] !== referenceElement || $[63] !== showTooltip ? (t19 = {
		handleIsOpenChange,
		referenceElement,
		showTooltip,
		isInsideGroup
	}, $[60] = handleIsOpenChange, $[61] = isInsideGroup, $[62] = referenceElement, $[63] = showTooltip, $[64] = t19) : t19 = $[64], useCloseOnMouseLeave(t19);
	let t20, t21;
	$[65] !== disabled || $[66] !== handleIsOpenChange || $[67] !== showTooltip ? (t20 = () => {
		disabled && showTooltip && handleIsOpenChange(!1);
	}, t21 = [
		disabled,
		handleIsOpenChange,
		showTooltip
	], $[65] = disabled, $[66] = handleIsOpenChange, $[67] = showTooltip, $[68] = t20, $[69] = t21) : (t20 = $[68], t21 = $[69]), useEffect(t20, t21);
	let t22, t23;
	$[70] !== content || $[71] !== handleIsOpenChange || $[72] !== showTooltip ? (t22 = () => {
		!content && showTooltip && handleIsOpenChange(!1);
	}, t23 = [
		content,
		handleIsOpenChange,
		showTooltip
	], $[70] = content, $[71] = handleIsOpenChange, $[72] = showTooltip, $[73] = t22, $[74] = t23) : (t22 = $[73], t23 = $[74]), useEffect(t22, t23);
	let t24, t25;
	$[75] !== handleIsOpenChange || $[76] !== showTooltip ? (t24 = () => {
		if (!showTooltip) return;
		let handleWindowKeyDown = function handleWindowKeyDown(event) {
			event.key === "Escape" && handleIsOpenChange(!1, !0);
		};
		return window.addEventListener("keydown", handleWindowKeyDown), () => {
			window.removeEventListener("keydown", handleWindowKeyDown);
		};
	}, t25 = [handleIsOpenChange, showTooltip], $[75] = handleIsOpenChange, $[76] = showTooltip, $[77] = t24, $[78] = t25) : (t24 = $[77], t25 = $[78]), useEffect(t24, t25);
	let t26;
	$[79] !== boundaryElement || $[80] !== portalElement?.offsetWidth ? (t26 = () => {
		let availableWidths = [...boundaryElement ? [boundaryElement.offsetWidth] : [], portalElement?.offsetWidth || document.body.offsetWidth];
		setTooltipMaxWidth(Math.min(...availableWidths) - 8);
	}, $[79] = boundaryElement, $[80] = portalElement?.offsetWidth, $[81] = t26) : t26 = $[81];
	let t27;
	$[82] !== boundaryElement || $[83] !== portalElement ? (t27 = [boundaryElement, portalElement], $[82] = boundaryElement, $[83] = portalElement, $[84] = t27) : t27 = $[84], useLayoutEffect(t26, t27);
	let t28;
	$[85] === update ? t28 = $[86] : (t28 = (arrowEl) => {
		arrowRef.current = arrowEl, update();
	}, $[85] = update, $[86] = t28);
	let setArrow = t28, t29;
	$[87] === refs ? t29 = $[88] : (t29 = (node) => {
		ref.current = node, refs.setFloating(node);
	}, $[87] = refs, $[88] = t29);
	let setFloating = t29, t30;
	bb0: {
		if (!childProp) {
			t30 = null;
			break bb0;
		}
		let t31;
		$[89] !== childProp || $[90] !== handleBlur || $[91] !== handleClick || $[92] !== handleContextMenu || $[93] !== handleFocus || $[94] !== handleMouseEnter || $[95] !== handleMouseLeave ? (t31 = cloneElement(childProp, {
			onBlur: handleBlur,
			onFocus: handleFocus,
			onMouseEnter: handleMouseEnter,
			onMouseLeave: handleMouseLeave,
			onClick: handleClick,
			onContextMenu: handleContextMenu,
			ref: setReferenceElement
		}), $[89] = childProp, $[90] = handleBlur, $[91] = handleClick, $[92] = handleContextMenu, $[93] = handleFocus, $[94] = handleMouseEnter, $[95] = handleMouseLeave, $[96] = t31) : t31 = $[96], t30 = t31;
	}
	let child = t30, t31;
	$[97] === childProp ? t31 = $[98] : (t31 = childProp ? getElementRef(childProp) : null, $[97] = childProp, $[98] = t31);
	let t32, t33;
	if ($[99] === referenceElement ? (t32 = $[100], t33 = $[101]) : (t32 = () => referenceElement, t33 = [referenceElement], $[99] = referenceElement, $[100] = t32, $[101] = t33), useImperativeHandle(t31, t32, t33), !child) {
		let t34;
		return $[102] === Symbol.for("react.memo_cache_sentinel") ? (t34 = /* @__PURE__ */ jsx(Fragment$1, {}), $[102] = t34) : t34 = $[102], t34;
	}
	if (disabled) return child;
	let t34 = tooltipMaxWidth > 0 ? `${tooltipMaxWidth}px` : void 0, t35;
	$[103] !== floatingStyles || $[104] !== t34 ? (t35 = {
		...floatingStyles,
		maxWidth: t34
	}, $[103] = floatingStyles, $[104] = t34, $[105] = t35) : t35 = $[105];
	let t36;
	$[106] !== animate || $[107] !== arrowProp || $[108] !== arrowX || $[109] !== arrowY || $[110] !== content || $[111] !== originX || $[112] !== originY || $[113] !== padding || $[114] !== placement || $[115] !== radius || $[116] !== restProps || $[117] !== scheme || $[118] !== setArrow || $[119] !== setFloating || $[120] !== shadow ? (t36 = /* @__PURE__ */ jsx(TooltipCard, {
		...restProps,
		animate,
		arrow: arrowProp,
		arrowRef: setArrow,
		arrowX,
		arrowY,
		originX,
		originY,
		padding,
		placement,
		radius,
		ref: setFloating,
		scheme,
		shadow,
		children: content
	}), $[106] = animate, $[107] = arrowProp, $[108] = arrowX, $[109] = arrowY, $[110] = content, $[111] = originX, $[112] = originY, $[113] = padding, $[114] = placement, $[115] = radius, $[116] = restProps, $[117] = scheme, $[118] = setArrow, $[119] = setFloating, $[120] = shadow, $[121] = t36) : t36 = $[121];
	let t37;
	$[122] !== restProps || $[123] !== setFloating || $[124] !== t35 || $[125] !== t36 || $[126] !== zOffset ? (t37 = /* @__PURE__ */ jsx(StyledTooltip, {
		"data-ui": "Tooltip",
		...restProps,
		ref: setFloating,
		style: t35,
		zOffset,
		children: t36
	}), $[122] = restProps, $[123] = setFloating, $[124] = t35, $[125] = t36, $[126] = zOffset, $[127] = t37) : t37 = $[127];
	let tooltip = t37, t38;
	$[128] !== portalProp || $[129] !== tooltip ? (t38 = portalProp ? /* @__PURE__ */ jsx(Portal, {
		__unstable_name: typeof portalProp == "string" ? portalProp : void 0,
		children: tooltip
	}) : tooltip, $[128] = portalProp, $[129] = tooltip, $[130] = t38) : t38 = $[130];
	let tooltipNode = t38, t39;
	$[131] !== animate || $[132] !== showTooltip || $[133] !== tooltipNode ? (t39 = animate ? /* @__PURE__ */ jsx(AnimateActivity, {
		layoutMode: "default",
		mode: showTooltip ? "visible" : "hidden",
		children: tooltipNode
	}) : /* @__PURE__ */ jsx(Activity, {
		mode: showTooltip ? "visible" : "hidden",
		children: tooltipNode
	}), $[131] = animate, $[132] = showTooltip, $[133] = tooltipNode, $[134] = t39) : t39 = $[134];
	let t40;
	return $[135] !== child || $[136] !== t39 ? (t40 = /* @__PURE__ */ jsxs(Fragment$1, { children: [t39, child] }), $[135] = child, $[136] = t39, $[137] = t40) : t40 = $[137], t40;
}
function useMiddleware(t0) {
	let $ = c(17), { animate, arrowProp, arrowRef, boundaryElement, fallbackPlacements, rootBoundary } = t0, ret;
	if ($[0] !== animate || $[1] !== arrowProp || $[2] !== arrowRef || $[3] !== boundaryElement || $[4] !== fallbackPlacements || $[5] !== rootBoundary) {
		ret = [];
		let t1 = boundaryElement || void 0, t2;
		$[7] !== fallbackPlacements || $[8] !== rootBoundary || $[9] !== t1 ? (t2 = flip({
			boundary: t1,
			fallbackPlacements,
			padding: 4,
			rootBoundary
		}), $[7] = fallbackPlacements, $[8] = rootBoundary, $[9] = t1, $[10] = t2) : t2 = $[10], ret.push(t2);
		let t3;
		$[11] === Symbol.for("react.memo_cache_sentinel") ? (t3 = offset({ mainAxis: 4 }), $[11] = t3) : t3 = $[11], ret.push(t3);
		let t4 = boundaryElement || void 0, t5;
		if ($[12] !== rootBoundary || $[13] !== t4 ? (t5 = shift({
			boundary: t4,
			rootBoundary,
			padding: 4
		}), $[12] = rootBoundary, $[13] = t4, $[14] = t5) : t5 = $[14], ret.push(t5), arrowProp) {
			let t6;
			$[15] === arrowRef ? t6 = $[16] : (t6 = arrow({
				element: arrowRef,
				padding: 4
			}), $[15] = arrowRef, $[16] = t6), ret.push(t6);
		}
		animate && ret.push(origin), $[0] = animate, $[1] = arrowProp, $[2] = arrowRef, $[3] = boundaryElement, $[4] = fallbackPlacements, $[5] = rootBoundary, $[6] = ret;
	} else ret = $[6];
	return ret;
}
/**
* As `useEffectEvent` should never be passed to other components or hooks, this custom hook groups together the `useEffectEvent` and the `useEffect` hook using it.
* @see https://19.react.dev/learn/separating-events-from-effects#reading-latest-props-and-state-with-effect-events:~:text=Never%20pass%20them%20to%20other%20components%20or%20Hooks
*/
function useCloseOnMouseLeave(t0) {
	let $ = c(10), { handleIsOpenChange, referenceElement, showTooltip, isInsideGroup } = t0, t1;
	$[0] !== handleIsOpenChange || $[1] !== referenceElement ? (t1 = (target, teardown) => {
		referenceElement && (referenceElement === target || target instanceof Node && referenceElement.contains(target) || (handleIsOpenChange(!1), teardown()));
	}, $[0] = handleIsOpenChange, $[1] = referenceElement, $[2] = t1) : t1 = $[2];
	let onMouseMove = useEffectEvent(t1), t2;
	$[3] !== isInsideGroup || $[4] !== onMouseMove || $[5] !== showTooltip ? (t2 = () => {
		if (!showTooltip || isInsideGroup) return;
		let handleMouseMove = (event) => {
			onMouseMove(event.target, () => window.removeEventListener("mousemove", handleMouseMove));
		};
		return window.addEventListener("mousemove", handleMouseMove), () => window.removeEventListener("mousemove", handleMouseMove);
	}, $[3] = isInsideGroup, $[4] = onMouseMove, $[5] = showTooltip, $[6] = t2) : t2 = $[6];
	let t3;
	$[7] !== isInsideGroup || $[8] !== showTooltip ? (t3 = [isInsideGroup, showTooltip], $[7] = isInsideGroup, $[8] = showTooltip, $[9] = t3) : t3 = $[9], useEffect(t2, t3);
}
/**
* @public
* Provides context for a group of tooltip elements that should share a delay
* which temporarily becomes 1 ms after the first floating element of the group opens.
*/
function TooltipDelayGroupProvider(props) {
	let $ = c(9), { children, delay } = props, [isGroupActive, setIsGroupActive] = useDelayedState(!1), [openTooltipId, setOpenTooltipId] = useDelayedState(null), openDelay = typeof delay == "number" ? delay : delay?.open || 0, closeDelay = typeof delay == "number" ? delay : delay?.close || 0, t0 = isGroupActive ? 1 : openDelay, t1;
	$[0] !== closeDelay || $[1] !== openTooltipId || $[2] !== setIsGroupActive || $[3] !== setOpenTooltipId || $[4] !== t0 ? (t1 = {
		setIsGroupActive,
		openTooltipId,
		setOpenTooltipId,
		openDelay: t0,
		closeDelay
	}, $[0] = closeDelay, $[1] = openTooltipId, $[2] = setIsGroupActive, $[3] = setOpenTooltipId, $[4] = t0, $[5] = t1) : t1 = $[5];
	let value = t1, t2;
	return $[6] !== children || $[7] !== value ? (t2 = /* @__PURE__ */ jsx(TooltipDelayGroupContext.Provider, {
		value,
		children
	}), $[6] = children, $[7] = value, $[8] = t2) : t2 = $[8], t2;
}
export { Tooltip, TooltipDelayGroupContext, TooltipDelayGroupProvider, useTooltipDelayGroup };

//# sourceMappingURL=tooltip.js.map